import { Loader } from "@fastoche/ui-core/loader";
import { LvLoadingOverlay } from "../../components";
/**
 * A Vue.js plugin for loading management.
 * <br>
 * <br>This plugin adds a `$loader` property to each component instance.
 * <br>The role of the loader is to track the loading of asynchronous tasks.
 * <br>
 * <br>If the option `loader` is set to `true` in the component's options, an overlay will be displayed while tasks are loading.
 */
export function LoaderPlugin() {
    return {
        install(_Vue, options) {
            _Vue.mixin({
                beforeCreate() {
                    this.__lvLoader = new Loader();
                },
                mounted() {
                    if (this.$options.loader !== true)
                        return;
                    const container = document.createElement("div");
                    container.classList.add("loading-container");
                    this.$el.appendChild(container);
                    this.__lvLoadingComponent = new LvLoadingOverlay({
                        parent: this,
                        propsData: _Vue.observable({
                            loader: this.$loader,
                        }),
                    }).$mount(container);
                },
                beforeDestroy() {
                    this.__lvLoader = null;
                    if (this.$options.loader !== true)
                        return;
                    this.__lvLoadingComponent?.$destroy();
                    this.__lvLoadingComponent?.$el.remove();
                    this.__lvLoadingComponent = null;
                },
            });
            Object.defineProperty(_Vue.prototype, "$loader", {
                get() {
                    return this.__lvLoader;
                },
            });
            _Vue.component("LvLoadingOverlay", LvLoadingOverlay);
        },
    };
}
//# sourceMappingURL=plugin.js.map